import { CopyIcon, MapPinIcon } from "@phosphor-icons/react";
import copy from "copy-to-clipboard";
import { useIntl } from "react-intl";

import { ButtonBase } from "@/components/ButtonBase/ButtonBase";
import { showSnackbar } from "@/contexts/SnackbarContext";
import { HotelMap } from "@/features/hotels/components/hotel/HotelMapLazy";
import type { FindHotelsHotelItemV2 } from "@/types/codegen";

type Props = {
  hotel: FindHotelsHotelItemV2;
};

export const HotelMapDirections = ({ hotel }: Props) => {
  const intl = useIntl();

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="text-lg font-medium text-text-primary">
        {intl.formatMessage({
          defaultMessage: "How to get to your hotel",
          description:
            "Hotel directions card title on hotel booking success page",
        })}
      </div>
      <HotelMap hotel={hotel} />
      {hotel.address ? (
        <ButtonBase
          onClick={() => {
            copy(hotel.address);
            showSnackbar({
              type: "success",
              content: intl.formatMessage({
                defaultMessage: "Hotel address copied",
                description:
                  "Snackbar text after user click copy address button on hotel booking success screen",
              }),
            });
          }}
          className="flex gap-2 text-start"
        >
          <MapPinIcon className="size-5 shrink-0" />
          <div className="flex grow-1 justify-between gap-1">
            <div className="text-sm text-text-tertiary">{hotel.address}</div>
            <CopyIcon className="size-5 shrink-0" />
          </div>
        </ButtonBase>
      ) : null}
    </div>
  );
};
